import React from 'react';
import { motion } from 'framer-motion';
import Navbar from '../components/Navbar';
import { Card } from '../components/ui';
import { FileText, Mail, MapPin } from 'lucide-react';

const Terms = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <div className="flex items-center gap-3 mb-6">
            <FileText className="w-8 h-8 text-primary" />
            <h1 className="font-heading text-3xl">KULLANIM ŞARTLARI</h1>
          </div>
          
          <p className="text-muted-foreground mb-8">
            Son Güncelleme: 22 Mart 2026
          </p>

          <Card className="p-8 space-y-8">
            <section>
              <h2 className="font-heading text-xl mb-4 text-primary">1. KABUL</h2>
              <p className="text-muted-foreground leading-relaxed">
                InkTrack uygulamasını ("Uygulama") kullanarak, bu Kullanım Şartlarını ("Şartlar") kabul etmiş 
                olursunuz. Bu Şartları kabul etmiyorsanız, Uygulamayı kullanmayınız. Uygulama, CEREBRAI VORTX 
                NÖROTEKNOLOJİ VE YAZILIM SİSTEMLERİ LİMİTED ŞİRKETİ ("CerebrAI-VorTX", "biz", "bizim") 
                tarafından işletilmektedir.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl mb-4 text-primary">2. HİZMET TANIMI</h2>
              <p className="text-muted-foreground leading-relaxed mb-4">
                InkTrack, dövme sahipleri için bakım takibi, koleksiyon yönetimi ve AI destekli analiz 
                hizmetleri sunan bir platformdur. Hizmetlerimiz şunları içerir:
              </p>
              <ul className="list-disc list-inside space-y-2 text-muted-foreground">
                <li>Dövme fotoğraf arşivi ve koleksiyon yönetimi</li>
                <li>İyileşme süreci takibi ve hatırlatıcılar</li>
                <li>AI destekli dövme sağlık analizi (Smart Check)</li>
                <li>AR dövme önizleme</li>
                <li>Dövme sanatçısı rehberi</li>
                <li>Vücut haritası ile planlama</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-xl mb-4 text-primary">3. HESAP OLUŞTURMA</h2>
              <p className="text-muted-foreground leading-relaxed">
                Uygulamayı kullanmak için bir hesap oluşturmanız gerekmektedir. Hesap oluştururken:
              </p>
              <ul className="list-disc list-inside space-y-2 text-muted-foreground mt-4">
                <li>Doğru ve güncel bilgiler sağlamalısınız</li>
                <li>Hesap güvenliğinizden siz sorumlusunuz</li>
                <li>18 yaşından büyük olmalısınız</li>
                <li>Hesabınızı başkalarıyla paylaşmamalısınız</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-xl mb-4 text-primary">4. ABONELİK VE ÖDEME</h2>
              <p className="text-muted-foreground leading-relaxed mb-4">
                InkTrack ücretsiz ve premium abonelik seçenekleri sunar:
              </p>
              <ul className="list-disc list-inside space-y-2 text-muted-foreground">
                <li><strong>Ücretsiz Plan:</strong> Temel özellikler, 3 dövme kaydı limiti</li>
                <li><strong>Aylık Premium:</strong> $4.99/ay - Sınırsız özellikler</li>
                <li><strong>Yıllık Premium:</strong> $39.99/yıl - Tüm özellikler + 2 ay ücretsiz</li>
              </ul>
              <p className="text-muted-foreground leading-relaxed mt-4">
                Ödemeler Stripe aracılığıyla güvenli şekilde işlenir. Aboneliğinizi istediğiniz zaman 
                iptal edebilirsiniz. İptal durumunda, mevcut fatura döneminin sonuna kadar hizmetler 
                aktif kalır.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl mb-4 text-primary">5. TIBBİ UYARI</h2>
              <div className="bg-yellow-500/10 border border-yellow-500/30 rounded-sm p-4">
                <p className="text-yellow-200 leading-relaxed">
                  <strong>ÖNEMLİ:</strong> InkTrack'in Smart Check özelliği yapay zeka destekli bir bilgilendirme 
                  aracıdır ve TIBBİ TEŞHİS YERİNE GEÇMEZ. Dövmenizde enfeksiyon belirtileri (aşırı kızarıklık, 
                  irin, ateş, şişlik) görürseniz derhal bir sağlık profesyoneline başvurunuz. AI analizleri 
                  yalnızca genel bilgilendirme amaçlıdır.
                </p>
              </div>
            </section>

            <section>
              <h2 className="font-heading text-xl mb-4 text-primary">6. KABUL EDİLEMEZ KULLANIM</h2>
              <p className="text-muted-foreground leading-relaxed mb-4">
                Aşağıdaki davranışlar kesinlikle yasaktır:
              </p>
              <ul className="list-disc list-inside space-y-2 text-muted-foreground">
                <li>Yasadışı veya uygunsuz içerik yüklemek</li>
                <li>Başkalarının kişisel bilgilerini paylaşmak</li>
                <li>Sistemi kötüye kullanmak veya manipüle etmek</li>
                <li>Sahte hesaplar oluşturmak</li>
                <li>Uygulamanın kaynak kodunu çıkarmaya çalışmak</li>
                <li>Diğer kullanıcılara zarar vermek</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-xl mb-4 text-primary">7. FİKRİ MÜLKİYET</h2>
              <p className="text-muted-foreground leading-relaxed">
                InkTrack uygulaması, logosu, tasarımı ve tüm içeriği CerebrAI-VorTX'in fikri mülkiyetidir. 
                Kullanıcılar tarafından yüklenen içeriklerin mülkiyeti kullanıcılara aittir, ancak 
                içeriklerin platformda kullanılması için bize lisans verilmiş sayılır.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl mb-4 text-primary">8. SORUMLULUK SINIRLAMASI</h2>
              <p className="text-muted-foreground leading-relaxed">
                CerebrAI-VorTX, uygulamanın kullanımından kaynaklanan doğrudan veya dolaylı zararlardan 
                sorumlu tutulamaz. Uygulama "olduğu gibi" sunulmaktadır ve kesintisiz veya hatasız 
                çalışacağına dair garanti verilmemektedir.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl mb-4 text-primary">9. DEĞİŞİKLİKLER</h2>
              <p className="text-muted-foreground leading-relaxed">
                Bu Kullanım Şartlarını herhangi bir zamanda değiştirme hakkımızı saklı tutarız. 
                Önemli değişiklikler yapıldığında kullanıcılarımızı e-posta veya uygulama içi 
                bildirim ile haberdar edeceğiz.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl mb-4 text-primary">10. UYGULANACAK HUKUK</h2>
              <p className="text-muted-foreground leading-relaxed">
                Bu Şartlar, Türkiye Cumhuriyeti yasalarına tabidir. Herhangi bir uyuşmazlık durumunda 
                Şanlıurfa Mahkemeleri ve İcra Daireleri yetkilidir.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl mb-4 text-primary">11. İLETİŞİM</h2>
              <p className="text-muted-foreground leading-relaxed mb-4">
                Bu Kullanım Şartları hakkında sorularınız için:
              </p>
              <div className="space-y-3">
                <div className="flex items-center gap-3 text-muted-foreground">
                  <Mail className="w-5 h-5 text-primary" />
                  <span>info@cerebrai-vortx.com</span>
                </div>
                <div className="flex items-start gap-3 text-muted-foreground">
                  <MapPin className="w-5 h-5 text-primary flex-shrink-0 mt-1" />
                  <span>
                    Ulubağ Mah. Recep Tayyip Erdoğan Blv. Harran Üniversitesi Teknokent No: 287 A 
                    İç Kapı No: Z1 Haliliye / Şanlıurfa, Türkiye
                  </span>
                </div>
              </div>
            </section>
          </Card>

          <p className="text-center text-sm text-muted-foreground mt-8">
            © 2026 CEREBRAI VORTX NÖROTEKNOLOJİ VE YAZILIM SİSTEMLERİ LİMİTED ŞİRKETİ. Tüm hakları saklıdır.
          </p>
        </motion.div>
      </main>
    </div>
  );
};

export default Terms;
